import { render, staticRenderFns } from "./DistributionUnitActivationWizard.vue?vue&type=template&id=788e1c51&scoped=true&"
import script from "./DistributionUnitActivationWizard.vue?vue&type=script&lang=js&"
export * from "./DistributionUnitActivationWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e1c51",
  null
  
)

export default component.exports